import React, { useState } from 'react';
import { toast } from 'sonner';
import { Sparkles, Loader2, Check } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';
import { AddJudgeForm } from '../judicial/AddJudgeForm';

const Level = ({ court, value, onPick, testid }) => {
  const [all, setAll] = useState(false);
  const list = all ? court.members : court.members.slice(0, 8);
  return (
  <div data-testid={testid} className="mt-2">
    <p className="text-[11px] font-semibold text-slate-300">{court.name} <span className="font-normal text-slate-500">· {court.region}</span></p>
    <div className="mt-1 flex flex-wrap gap-1">
      {list.map((p) => (
        <button type="button" key={p.id} data-testid={`${testid}-member-${p.id}`} onClick={() => onPick(p)}
          className={`rounded-full border px-2 py-0.5 text-[11px] transition-colors ${value === p.id ? 'border-amber-500 bg-amber-500 text-slate-950' : 'border-slate-600 text-slate-300 hover:border-amber-500'}`}>
          {p.name} · {p.position}
        </button>
      ))}
      {!court.members.length && <span className="text-[10px] text-slate-500">Sin nómina publicada</span>}
      {court.members.length > 8 && <button type="button" data-testid={`${testid}-toggle-all`} onClick={() => setAll((v) => !v)} className="text-[11px] text-amber-300 hover:underline">{all ? 'Ver menos' : `Ver los ${court.members.length}`}</button>}
    </div>
  </div>
  );
};

// Fidem suggests the competent court (+ appeal chain) for the case; the lawyer confirms the judge or picks manually
export const CourtSuggest = ({ matter, value, onPick, onUpdated }) => {
  const { api } = useAuth();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setS(await runAiJob(api, `/courts/matters/${matter.id}/suggest`, {}, { timeout: 120000 })); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const assignCourt = async () => {
    try { await api.patch(`/crm/matters/${matter.id}`, { court: s.court.name, court_slug: s.court.slug }); toast.success('Tribunal asignado a la causa'); onUpdated(); }
    catch (e) { toast.error(e.response?.data?.detail || 'No se pudo asignar'); }
  };
  if (!s) return (
    <button type="button" data-testid={`court-suggest-btn-${matter.id}`} onClick={run} disabled={busy} className="flex items-center gap-1.5 rounded-full border border-amber-500/50 px-3 py-1 text-xs text-amber-300 disabled:opacity-60">
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Sparkles className="h-3 w-3" />}{busy ? 'Fidem busca el tribunal...' : 'Fidem sugiere tribunal y juez'}
    </button>
  );
  if (!s.court) return <p data-testid={`court-suggest-none-${matter.id}`} className="text-xs text-slate-400">{s.reason}</p>;
  return (
    <div data-testid={`court-suggest-${matter.id}`} className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-3">
      <p className="text-xs text-amber-100"><Sparkles className="mr-1 inline h-3 w-3" />Fidem sugiere: <b>{s.court.name}</b>. {s.reason}</p>
      <Level court={s.court} value={value} onPick={(p) => onPick(p.id)} testid={`court-suggest-first-${matter.id}`} />
      <AddJudgeForm slug={s.court.slug} testid={`court-suggest-add-${matter.id}`} onAdded={(j) => { onPick(j.id); setS({ ...s, court: { ...s.court, members: [...s.court.members.filter((m) => m.id !== j.id), { id: j.id, name: j.name, position: 'Juez' }] } }); }} />
      {s.appeal_chain.map((c) => <Level key={c.slug} court={c} value={value} onPick={(p) => onPick(p.id)} testid={`court-suggest-${c.slug}-${matter.id}`} />)}
      <button type="button" data-testid={`court-suggest-assign-${matter.id}`} onClick={assignCourt} className="mt-3 flex items-center gap-1 rounded-full border border-slate-600 px-3 py-1 text-[11px] text-slate-200 hover:border-amber-500"><Check className="h-3 w-3" />Asignar solo el tribunal</button>
    </div>
  );
};
